// extracted by mini-css-extract-plugin
export default {"baseText":"BJn6yNt7AYRStg_tSJGt"};